var __webpack_exports__ = {};
/*!***************************************!*\
  !*** ./src/js/menu-drawer-manager.js ***!
  \***************************************/
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var MenuManager = /*#__PURE__*/function () {
  function MenuManager() {
    _classCallCheck(this, MenuManager);
    this.headerSection = document.querySelector('.shopify-section-group-header-group');
    this.iconLinks = document.querySelectorAll('.icon-link[data-menu-open-target]');
    this.mainMenu = document.querySelector('#menu-drawer');
    this.mainMenuDetails = document.querySelector('header-drawer details.menu-drawer-container');
    this.mainMenuSummary = this.mainMenuDetails.querySelector('summary');
    this.iconClose = document.querySelector('.icone-close');
    this.iconMainMenu = document.querySelector('.icon-hamburger');
    this.headerOverlay = document.querySelector('.header-overlay');
    this.headerCommuns = document.querySelector('.header-communs');
    this.burgerIcon = document.querySelector('#menuToggle');
    this.destinationMenu = document.querySelector('#menu-drawer-destination');
    this.btnLocation = document.querySelector('.location-selector__button');
    this.bindEvents();
    this.formatPhoneNumberLinks(this.mainMenuDetails);
  }
  _createClass(MenuManager, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this = this;
      this.iconLinks.forEach(function (link) {
        link.addEventListener('click', _this.handleIconLinkClick.bind(_this));
      });
      if (this.btnLocation) {
        this.btnLocation.addEventListener('click', this.handleLocationButtonClick.bind(this));
      }
      if (this.iconClose) {
        this.iconClose.addEventListener('click', this.handleIconCloseClick.bind(this));
        this.iconClose.addEventListener('mouseenter', this.handleBurgerIconMouseEnter.bind(this));
        this.iconClose.addEventListener('mouseleave', this.handleBurgerIconMouseLeave.bind(this));
      }
    }
  }, {
    key: "handleBurgerIconMouseEnter",
    value: function handleBurgerIconMouseEnter() {
      this.burgerIcon.classList.add('hover-effect');
    }
  }, {
    key: "handleBurgerIconMouseLeave",
    value: function handleBurgerIconMouseLeave() {
      this.burgerIcon.classList.remove('hover-effect');
    }
  }, {
    key: "formatPhoneNumberLinks",
    value: function formatPhoneNumberLinks(parentDetails) {
      var phoneLinks = parentDetails.querySelectorAll('a[href*="tel:"]');
      phoneLinks.forEach(function (link) {
        var linkText = link.textContent;
        var match = linkText.match(/\(([^)]+)\)/);
        if (match) {
          var beforeParentheses = linkText.replace(match[0], '').trim();
          link.innerHTML = "".concat(beforeParentheses, " <br>(").concat(match[1], ")");
        }
      });
    }
  }, {
    key: "handleIconLinkClick",
    value: function handleIconLinkClick(event) {
      var targetValue = event.currentTarget.dataset.menuOpenTarget;
      var targetSummary = document.querySelector("summary[aria-controls=\"link-".concat(targetValue, "\"]"));
      this.mainMenu.classList.add('from-icon');
      if (targetSummary) {
        targetSummary.setAttribute('aria-expanded', 'true');
        var parentDetails = targetSummary.closest('details');
        if (parentDetails) {
          parentDetails.classList.add('from-icon');
          parentDetails.classList.add('menu-opening');
          parentDetails.setAttribute('open', '');
          var parentUl = parentDetails.closest('ul.has-submenu');
          if (parentUl) {
            parentUl.classList.add('submenu-open');
            parentUl.classList.add('from-icon');
          }
        }
        this.headerOverlay.classList.add('header-overlay--open');

        // Gestion du menu principal 
        if (this.mainMenuDetails && this.mainMenuSummary) {
          this.mainMenuDetails.classList.add('menu-opening');
          this.mainMenuDetails.setAttribute('open', '');
          this.mainMenuSummary.setAttribute('aria-expanded', 'true');
        }
        if (this.burgerIcon) {
          this.burgerIcon.classList.add('burger-active');
        }
      }
    }
  }, {
    key: "handleLocationButtonClick",
    value: function handleLocationButtonClick() {
      if (this.destinationMenu) {
        this.destinationMenu.classList.add('open');
        this.headerOverlay.classList.add('header-overlay--open');
        this.headerCommuns.classList.add('hide');
        this.burgerIcon.classList.add('burger-active');
        this.headerSection.classList.add('menu-open');
        document.querySelector('body').classList.add('overflow-hidden-desktop');
      }
    }
  }, {
    key: "handleIconCloseClick",
    value: function handleIconCloseClick() {
      var _this2 = this;
      if (!this.headerOverlay.classList.contains('header-overlay--open')) {
        return;
      }
      if (this.destinationMenu && this.destinationMenu.classList.contains('open')) {
        setTimeout(function () {
          var detailsElements = document.querySelectorAll('.menu-drawer-container');
          detailsElements.forEach(function (detail) {
            detail.removeAttribute('open');
            var summaryElement = detail.querySelector('summary');
            if (summaryElement) {
              summaryElement.setAttribute('aria-expanded', 'false');
            }
          });

          // Delay the following actions
          setTimeout(function () {
            return _this2.handleCloseActions();
          }, 50);
        }, 50);
      } else {
        this.handleCloseActions();
      }
      this.headerCommuns.classList.remove('hide');
      this.headerSection.classList.remove('menu-open');
    }
  }, {
    key: "handleCloseActions",
    value: function handleCloseActions() {
      this.headerOverlay.classList.remove('header-overlay--open');
      if (this.destinationMenu) {
        this.destinationMenu.classList.remove('open');
      }
      if (this.burgerIcon) {
        this.burgerIcon.classList.remove('burger-active');
        this.iconMainMenu.style.pointerEvents = 'none';
      }
      document.querySelector('body').classList.remove('overflow-hidden-desktop');
      this.headerSection.classList.remove('menu-open');
    }
  }]);
  return MenuManager;
}();
window.addEventListener('DOMContentLoaded', function () {
  new MenuManager();
});
